import React from "react";
import Layout from "../components/layout";
import ZipFinder from '../components/zip-finder';
import AreYouAProfessional from '../components/are-you-a-professional';
import StatesList from '../components/states-list';
import CitiesList from '../components/cities-list';
import WhatService from '../components/what-service';
import HowToGuidesImage from '../components/how-to-guides-image';
import KeygroupsImages from '../components/keygroups-images';
import PopularProjectsNearYou from "../components/popular-projects-near-you";
import HowNearMe from "../components/how-nearme";
import ProjectTypesList from "../components/project-types-list";

const PROPAGE = ({ pageContext }) => 
{    
    const main_menu = pageContext.main_menu;
    const footer_menu = pageContext.footer_menu;
    
    const states = pageContext.states.length > 0 ? pageContext.states : [];
    const codes = pageContext.codes.length > 0 ? pageContext.codes : [];
    const code = pageContext.code;    
    const env = pageContext.env;
    const modal_project_types = pageContext.modal_project_types;
    const cities = pageContext.cities.length > 0 ? pageContext.cities : [];
    const project_types = pageContext.project_types
    const popular_projects = pageContext.popular_projects

    const HUB = pageContext.HUB;

    if(HUB.length > 0) cities.push(HUB[0])

    const placeholder = "Enter Zip Code";
    const button = env.site === 'dumpster' ? "Find Pros" : "Get Started";
    const bottomtext = env.site === 'dumpster' ? "America's #1 Source for Dumpsters and Junk Removal" : "America's #1 Source for Local Demolition Experts";
    const hideCities = env.site === 'dumpster' ? false : true;
    const finderopenmodal = env.site === 'dumpster' ? false : true;

    const hide_in_dumpster = env.site === 'dumpster' ? false : true;
    const hide_in_demolition = env.site === 'demolition' ? false : true;

    const seo_desc = pageContext.seo_desc;
    const seo = 
    {
        url: pageContext.url,
        env: env,
        code: code,
        page: 'home',
        seo_desc: seo_desc
    }

    return (

        <Layout seo={seo} env={env} code={code} main_menu={main_menu} footer_menu={footer_menu}>
            
            <ZipFinder
                id= 'home-zip-code'
                code = {code}
                placeholder = {placeholder}
                button = {button}
                bottomtext = {bottomtext}
                codes = {codes}
                env = {env} 
                finderopenmodal = {finderopenmodal}
                class = 'small'
                /> 

            <KeygroupsImages
                hide={hide_in_demolition}
                code = {code}
                />

            <WhatService 
                hide={hide_in_dumpster}  env={env}
                />

            <PopularProjectsNearYou popular_projects={popular_projects} env={env}/>

            <HowNearMe 
                hide={false}
                code={code}
                page='home'
            />

            <CitiesList 
                cities = {cities}
                code = {code}
                codes = {codes}
                page = 'pro'
                // hide = {hideCities} 
                env = {env} 
            />
            
            <HowToGuidesImage
                hide={hide_in_dumpster}
                code={code}
                />

            <AreYouAProfessional env={env} page='pro'/>

            <StatesList 
                states = {states}                    
                code = {code}     
                codes = {codes}
                env = {env}
                page = 'pro'
                section='state'
                /> 
            
            <ProjectTypesList 
                title='Popular Categories'
                project_types={project_types}
                env={env}
            />


        </Layout>
   )
};

export default PROPAGE;